export function PublishIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M8.75025 11.2501L17.5003 2.50014M8.85657 11.5235L11.0467 17.1552C11.2396 17.6513 11.3361 17.8994 11.4751 17.9718C11.5956 18.0346 11.7391 18.0347 11.8597 17.972C11.9988 17.8998 12.0955 17.6518 12.2891 17.1559L17.781 3.08281C17.9557 2.63516 18.043 2.41133 17.9953 2.26831C17.9538 2.1441 17.8563 2.04663 17.7321 2.00514C17.5891 1.95736 17.3652 2.0447 16.9176 2.21939L2.84447 7.71134C2.34857 7.90486 2.10062 8.00163 2.02837 8.14071C1.96573 8.26129 1.96581 8.40483 2.02859 8.52533C2.10101 8.66433 2.34907 8.7608 2.84519 8.95373L8.47686 11.1438C8.57757 11.183 8.62793 11.2026 8.67033 11.2328C8.70791 11.2596 8.74077 11.2925 8.76758 11.3301C8.79782 11.3725 8.81741 11.4228 8.85657 11.5235Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "ShareIcon";
